import { IPassportSchema } from '@/pages/MDM/mdm.types.ts'
import usePassportSchemas from '@/pages/MDM/hooks/usePassportSchemas.ts'
import { useMemo } from 'react'

const usePassportSchema = (id: IPassportSchema['id']) => {
  const schemas = usePassportSchemas()

  return useMemo(() => {
    return schemas.find((s) => s.id === id)
  }, [schemas, id])
}

export default usePassportSchema
